import { profileApi } from '@/lib/api/profile';
import { ProfileDto, ConsultantCredentialsStatus } from '@paladin-monorepo/common';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const Contact = ({ profile }: { profile: ProfileDto }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col xl:flex-row md:items-center md:gap-4">
      <img
        src={profileApi.getProfilePhotoUrl(profile.id)}
        alt={`${profile.firstName} ${profile.lastName} profile`}
        className="h-24 w-24 rounded-full object-cover border"
      />

      <div>
        <p className="font-medium">
          {profile.firstName} {profile.lastName}
        </p>
        <p className="text-sm text-muted-foreground">{profile.jobTitle}</p>
        {profile.consultantCredentialsStatus === ConsultantCredentialsStatus.Verified && (
          <Badge variant="secondary" className="mt-1">
            {t('profile.personalInfo.consultantCredentials.status.verified')}
          </Badge>
        )}
        {(profile.linkedinUrl || profile.portfolioUrl) && (
          <div className="flex flex-wrap gap-2 mt-2 text-sm">
            {profile.linkedinUrl && (
              <a
                href={profile.linkedinUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                LinkedIn
              </a>
            )}
            {profile.portfolioUrl && (
              <a
                href={profile.portfolioUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                {t('profile.personalInfo.portfolio.label')}
              </a>
            )}
          </div>
        )}

        <p className="text-sm text-muted-foreground">{profile.phone}</p>
        <p className="text-sm text-muted-foreground">{profile.email}</p>
      </div>
    </div>
  );
};
